export default __webpack_public_path__ + "static/media/supply-icon-black.9995fd6f.svg";